module.exports = __webpack_public_path__ + "static/media/iphone_12_mini_white.5358b90d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_mini_white.png
// module id = 2081
// module chunks = 0